export default "__VITE_ASSET__Dwsn9eGK__"